import { Component, OnInit } from '@angular/core';
import { AppServiceService } from '../../app-service.service';
import { 
  contactAnimatePageForm, 
  contactFormAnimate
} from '../../animation/animate';
import { ApiService } from '../../api.service';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
  animations: [
    contactAnimatePageForm, 
    contactFormAnimate
  ],
  host: { '[@contactAnimatePageForm]': '' }
}) 
export class ContactFormComponent implements OnInit {
  private ngUnsubscribe: Subject<boolean> = new Subject();
  private send:string = 'show';
  private stateTitle:string = 'hide';

  private message:any = {
    'name' : '',
    'phone' : '',
    'email' : ''
  };
  private post:any;
  public screen:any = {
    'width' : '1920',
    'height': '1080'
  };

  constructor(
    private app: AppServiceService, 
    private api: ApiService,
    private route: ActivatedRoute
  ) { 
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.post = data.data;
    })
    
    this.app.normalMenu.next(false);
  }

  ngOnInit() {
    //screen
    this.screen = this.app.screen;
    this.app.screenSubject.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.screen = this.app.screen;
    })

    setTimeout(() => {
      this.app.showLeftPanel.next(true);   
      this.app.blackStyle.next(true);
      this.app.activeMenu.next(true);

      this.app.title.next('Contact form');
      this.app.titleLeftPanel.next(true);
    }, 2000);
  }

  sendMessage(){
    this.api.sendMessage(this.message).subscribe(data => {
      if(data['mail']){
        //this.UI.showContactModalSend();
        this.send = 'hide';
        this.message = {
          'name' : '',
          'phone' : '',
          'email' : ''
        };
      }
    });
  }

  
  changeState(event){
    if(event.toState == 'hide'){
      this.stateTitle = 'show';
    }
  }

  ngOnDestroy(){
    this.app.titleLeftPanel.next(false);

    this.app.activeMenu.next(false);
    this.app.blackStyle.next(false);
    this.app.menuState.next('hide');
    this.app.submenuState.next('hide');

    setTimeout(() => {
      this.app.title.next('');
    }, 500);
    
    //unsabscribe
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/contact/contact-form/contact-form.component.ts